/**
 * Domain to Language Mapping Configuration
 * 
 * This configuration maps domain names to language codes.
 * Add new domains or modify existing ones as needed.
 * 
 * Format: { 'domain': 'language-code' }
 */
export const DOMAIN_LANGUAGE_CONFIG: { [domain: string]: string } = {
  // US domains - default to US English
  'afp.mcgriffportal.com': 'en-US',
  'us.afp.mcgriffportal.jetfiletech.net': 'en-US',

  // Production domains
  'de.afp.mcgriffportal.jetfiletech.net': 'de-DE',
  'fr.afp.mcgriffportal.jetfiletech.net': 'fr-FR', 
  'uk.afp.mcgriffportal.jetfiletech.net': 'en-GB',
  'es.afp.mcgriffportal.jetfiletech.net': 'es-ES',
  'it.afp.mcgriffportal.jetfiletech.net': 'it-IT',
  'eu.afp.mcgriffportal.jetfiletech.net': 'en-GB',

  // Development/staging domains (examples)
  'de-dev.afp.mcgriffportal.jetfiletech.net': 'de-DE',
  'fr-dev.afp.mcgriffportal.jetfiletech.net': 'fr-FR',
  'uk-dev.afp.mcgriffportal.jetfiletech.net': 'en-GB',
  'es-dev.afp.mcgriffportal.jetfiletech.net': 'es-ES',
  'it-dev.afp.mcgriffportal.jetfiletech.net': 'it-IT',
  'eu-dev.afp.mcgriffportal.jetfiletech.net': 'en-GB',

  // Localhost development
  'de.localhost': 'de-DE',
  'fr.localhost': 'fr-FR',
  'uk.localhost': 'en-GB',
  'es.localhost': 'es-ES',
  'it.localhost': 'it-IT',
  'eu.localhost': 'en-GB'
};

/**
 * Default fallback language when no domain mapping is found
 */
export const DEFAULT_LANGUAGE = 'en-GB';

/**
 * Domains where the language selector should be hidden
 * These domains will auto-select their language and not show the language switcher
 */
export const DOMAINS_HIDE_LANGUAGE_SELECTOR = [
  'afp.mcgriffportal.com',
  'us.afp.mcgriffportal.jetfiletech.net'
];